import { render, staticRenderFns } from "./custom-scale.vue?vue&type=template&id=bd9a3f04&scoped=true&"
import script from "./custom-scale.vue?vue&type=script&lang=js&"
export * from "./custom-scale.vue?vue&type=script&lang=js&"
import style0 from "./custom-scale.vue?vue&type=style&index=0&id=bd9a3f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9a3f04",
  null
  
)

component.options.__file = "custom-scale.vue"
export default component.exports